// @ts-check
import React from 'react'
import { isEmpty, isNil } from 'ramda'
import cn from 'classnames'
import styles from './style.css'

/**
 * @param {{ value: string | React.Component, className?: string }} props
 */
const Error = ({ value, className }) =>
  !isEmpty(value) && !isNil(value) ? <div className={cn(styles.error, className)}>{value}</div> : null

export { Error }
